import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import TermsAndConditions from '../components/Terms/TermsAndConditions'
import Footer from '../components/Footer/Footer'

const Termspage = () => {
  return (
    <div>

        <Navbar/>
        <TermsAndConditions/>
        <Footer/>
    </div>
  )
}

export default Termspage